import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Callback from './scenes/Callback/index';
import NewDelivery from './scenes/Admin/scenes/Deliveries/scenes/New';
import AdminArea from './scenes/Admin/';
import SecuredRoute from './components/SecuredRoute/SecuredRoute';
import NotFound from './scenes/NotFound';
import Verify from './scenes/Verify';
import Mfa from './scenes/Mfa';
import Login from './scenes/Login';
import CustomerUpload from './scenes/Customer/scenes/Upload';
import Uploads from './scenes/Admin/scenes/Uploads/';
import Deliveries from './scenes/Customer/scenes/Deliveries';
import UploadConfirmation from './scenes/Customer/scenes/Upload/scenes/UploadConfirmation';
import applyTheme from './components/applyTheme/applyTheme';

const App = ({ theme }) => {
  const myTheme = {
    "--themeColor": theme.themeColor,
    "--accentColor": theme.accentColor,
    "--actionColor": theme.actionColor,
    "--successColor": theme.successColor,
    "--dangerColor": theme.dangerColor,
  }
  applyTheme(myTheme);
  
  return (
    <Routes>
      <Route path='/' element={<Navigate to="/delivery" replace />} />
      
      {/* Public area */}
      <Route path='/delivery' element={<Deliveries />} />
      <Route path='/delivery/find' element={<Deliveries />} />
      <Route 
        path='/upload' 
        element={
          <SecuredRoute scopes={[]}>
            <CustomerUpload title="Ladda upp filer" />
          </SecuredRoute>
        } 
      />
      <Route 
        path='/uploadconfirmed' 
        element={
          <SecuredRoute scopes={[]}>
            <UploadConfirmation title="Ladda upp filer" />
          </SecuredRoute>
        } 
      />
      
      {/* Admin area */}
      <Route 
        path='/admin' 
        element={
          <SecuredRoute scopes={['deliveries:send-to-customer', 'deliveries:receive-from-customer']}>
            <AdminArea title="Admin" />
          </SecuredRoute>
        } 
      />
      <Route 
        path='/admin/deliveries/new' 
        element={
          <SecuredRoute scopes={['deliveries:send-to-customer']}>
            <NewDelivery title="Filleverans" />
          </SecuredRoute>
        } 
      />
      <Route 
        path='/admin/uploads/*' 
        element={
          <SecuredRoute scopes={['deliveries:receive-from-customer']}>
            <Uploads title="Kunduppladdningar" />
          </SecuredRoute>
        } 
      />
      
      {/* Misc */}
      <Route path='/mfa' element={<Mfa />} />
      <Route path='/verify' element={<Verify />} />
      <Route path='/login' element={<Login />} />
      <Route path='/callback' element={<Callback />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
};

export default App;
